import '@babel/polyfill'
import shopifyConnector from '../../helpers/shopify-api.js'

export default {
  state: {
    cartFlag: false,
    searchFlag: false,
    cart: [],
    subTotal: 0,
    rebuildCart: false,
    childDataLoaded: false,
  },
  getters: {
    cartCount: state => {
      let lineItemQunatities = state.cart.map(item => item.qty)
      let totalQuantity = 0

      lineItemQunatities.forEach(function(item) {
        totalQuantity += item
      })

      return totalQuantity
    },
  },
  mutations: {
    showCart(state, onlyHide = false) {
      if (onlyHide) {
        return (state.cartFlag = false)
      } else {
        return (state.cartFlag = !state.cartFlag)
      }
    },
    getCart(state) {
      shopifyConnector.loadCart().then(response => {
        state.subTotal = response[response.length - 1].total_price
        response.pop()
        state.cart = response
        state.childDataLoaded = true

        return state
      })
    },
    changeCart(state, payload) {
      shopifyConnector.changeCartContent(payload.quantity, payload.index).then(response => {
        state.subTotal = response[response.length - 1].total_price
        response.pop()
        state.cart = response

        /*
            We check if the new quantity returned after a successful change.js ajax request
            If the expected value is higher than the returned value by one, we display the only one left message (#OutOfStock-)
            else we display a custom message suggesting they update quantity by 1
          */
        if (
          state.cart[payload.index].qty &&
          state.cart[payload.index].qty !== null &&
          typeof state.cart[payload.index].qty !== 'undefined'
        ) {
          if (payload.quantity > state.cart[payload.index].qty) {
            if (payload.quantity == state.cart[payload.index].qty + 1) {
              document.getElementById('outOfStock-' + payload.id).style.height = '30px'
              document.getElementById('qty-plus-' + payload.id).disabled = true
              document.getElementById('cdupdates_' + payload.id).disabled = true
            } else {
              document.getElementById('customMessage-' + payload.id).style.height = '30px'
            }
          }
        }

        return state
      })
    },
    updateCart(state, payload) {
      let quantity = payload.quantity

      for (let i = 0; i < state.cart.length; i++) {
        if (payload.id == state.cart[i].id) {
          quantity = quantity + state.cart[i].qty
        }
      }

      state.childDataLoaded = false
      shopifyConnector.updateCartContent(payload.id, quantity).then(response => {
        state.subTotal = response[response.length - 1].total_price
        response.pop()
        state.cart = response
        state.cartFlag = !state.cartFlag
        state.rebuildCart = true
        state.childDataLoaded = true

        return state
      })
    },
    addToCart(state, payload) {
      let quantity = payload.quantity

      shopifyConnector.addToCart(payload, state.subTotal).then(response => {
        state.subTotal = response[response.length - 1].total_price
        response.pop()
        state.cart = response
        state.cartFlag = !state.cartFlag
        state.rebuildCart = true
        state.childDataLoaded = true

        return state
      })
    },
  },
  actions: {
    getCart({ commit }) {
      commit('getCart')
    },
    updateCart({ commit }, payload) {
      commit('updateCart', payload)
    },
    changeCart({ commit }, payload) {
      commit('changeCart', payload)
    },
    addToCart({ commit }, payload) {
      return new Promise((resolve, reject) => {
        commit('addToCart', payload)
        resolve()
      })
    },
    addtoCartDeploy({ dispatch, commit }, payload) {
      dispatch('addToCart', payload).then(() => {
        setTimeout(function() {
          commit('showCart', true)
        }, 8000)
      })
    },
  },
}
